import * as React from 'react'
import { FastField } from 'formik'

import { DebouncedTextField } from '@user/components/Formik'

type Props = {
  disabled: boolean
}

export function SalesNoteField(props: Props) {
  const { disabled } = props

  return (
    <FastField
      component={DebouncedTextField}
      disabled={disabled}
      label="Sales Note"
      name="salesNote"
      margin="normal"
      fullWidth
      multiline
      minRows={2}
      inputProps={{
        maxLength: 500,
      }}
    />
  )
}
SalesNoteField.displayName = 'SalesNoteField'
